"use client";

// Deterministic "the app is interactive" signal for e2e tests.
//
// The root layout renders `<body class="e2e-waiting">`. This module clears that
// class once the app has hydrated AND no full-screen loader is on screen, and
// re-adds it whenever a loader mounts again. The e2e harness's navigation
// helper waits for the class to clear before driving the next step, so it never
// races hydration or a page's data-prime (e.g. the /inspections offline-cache
// loader) with a fixed timeout.
//
// Shipping this to production is intentional and harmless: a single class
// toggle on <body>, with no visual or behavioural effect.

let hydrated = false;
let activeLoaders = 0;

function sync(): void {
  if (typeof document === "undefined") return;
  const lively = hydrated && activeLoaders === 0;
  document.body.classList.toggle("e2e-waiting", !lively);
}

// Called once the client has hydrated and the root content is mounted. Releases
// the server-rendered baseline so pages that never show a loader still settle.
export function markAppHydrated(): void {
  hydrated = true;
  sync();
}

// Each mounted FullScreenLoader holds the app "not lively". Returns the release
// to call on unmount; the count handles concurrent loaders.
export function registerFullScreenLoader(): () => void {
  activeLoaders += 1;
  sync();
  return () => {
    activeLoaders = Math.max(0, activeLoaders - 1);
    sync();
  };
}
